import Request from './request'

const Device_List = {
  getCustomDeviceList (callback) {
    Request.get('custom-device-list').then(callback).catch(this.bad_answer)
  },
  // getCustomListAll (callback) {
  //   Request.get('custom-device-list').then(callback).catch(this.bad_answer)
  // },
  createCustomDeviceList (params, callback) {
    Request.post('custom-device-list/create', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  editCustomDeviceList (id, params, callback) {
    Request.post('custom-device-list/edit/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  deleteCustomDeviceList (id, callback) {
    Request.delete('custom-device-list/delete/' + id).then(callback).catch(this.bad_answer)
  },
  getInfoCustomDeviceList (id, callback) {
    Request.post('custom-device-list/view/' + id).then(callback).catch(this.bad_answer)
  },
  addDevicesCustomDeviceList (params, callback) {
    Request.post('custom-device-list/add-devices', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  removeDeviceCustomDeviceList (params, callback) {
    Request.delete('custom-device-list/remove-device', params).then(callback).catch(this.bad_answer)
  },
  addUserCustomDeviceList (params, callback){
    Request.post('custom-device-list/add-user', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  removeUserCustomDeviceList (params, callback){
    Request.delete('custom-device-list/remove-user', params).then(callback).catch(this.bad_answer)
  }
}
export default Device_List
